import type { PublicFile, PublicFileGallery, PublicFileListResponse } from '@mds/shared/types/file';

import { api } from '@/lib/api';

/**
 * The public images in a gallery's folder of the file library, in name order. Empty when the
 * folder is missing or holds nothing public — see `backend/docs/file-storage.md`.
 */
export const getGallery = (gallery: PublicFileGallery): Promise<PublicFile[]> =>
  api.get<PublicFileListResponse>(`files/galleries/${gallery}`).then((r) => r.data);
